const roleTypesSettings = {
  admin: { abbr: "AD", color: "bg-gray-500" },
  CS: { abbr: "CS", color: "bg-red-500" },
  field: { abbr: "FI", color: "bg-am-500" },
  area_manager: { abbr: "AM", color: "bg-yellow-400" },
  agent: { abbr: "AG", color: "bg-indigo-500" },
  enterprise: { abbr: "EN", color: "bg-pink-500" },
  design_studio: { abbr: "DS", color: "bg-blue-500" },
  freelance: { abbr: "FR", color: "bg-green-500" },
  private: { abbr: "PR", color: "bg-purple-500" },
  resale: { abbr: "RE", color: "bg-pink-500" },
  sales_director: { abbr: "DV", color: "bg-yellow-600" },
};

export default roleTypesSettings;
